export default {
  general: {
    primaryColor: '#E39A46',
    secondaryColor: '#000000',
  },
  login: {
    backgroundColor: '#313340ad',
    logo: {
      width: 200,
      height: 140,
    },
    form: {
      textColor: '#969696',
      labelColor: '#FFFFFF',
      borderColor: '#969696',
      buttonTextColor: '#fff',
    },
  },
  menu: {
    backgroundColor: '#151515',
    logo: {
      width: 120,
      height: 'auto',
    },
    header: {
      // borderColor: '#3d3d58',
      // You can add any css here
      paddingBottom: 0,
      paddingTop: 10,
      textAlign: 'left'
    },
    items: {
      textColor: '#9898A2',
      iconColor: '#9898A2',
      activeIconColor: '#FFFFFF',
      activeBackgroundColor: '#E39A46',
      activeTextColor: '#FFFFFF',
      subHeaderColor: '#fff',
    },
  },
};
